module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p12s1Title":"Frequently asked questions about professional practices in companies"},"es":{"p12s1Title":"Preguntas frecuentes sobre las prácticas profesionales en empresas"}}')
  delete Component.options._Ctor
}
